import {SearchByPhoneNumberStrategy} from "./search-by-phone-number.strategy";
import {observer} from "mobx-react";
import React from "react";
import {BookingSearchCommonFieldsComponent} from "../common/booking-search-common-fields.component";
import {BookingSearchFieldsContainerBox} from "../common/booking-search-fields-container.box";
import {PhoneFieldEditorComponent} from "../../../../components/forms/contact/phone-field-editor.component";

export const SearchByPhoneNumberComponent: React.FC<{ strategy: SearchByPhoneNumberStrategy }> = observer((props) => {
    const fields = props.strategy.fields;

    return (
        <BookingSearchFieldsContainerBox>
            <PhoneFieldEditorComponent field={fields.phoneNumber} showClearButton={true}/>
            <BookingSearchCommonFieldsComponent fields={fields} />
        </BookingSearchFieldsContainerBox>
    );
});
